import tooManyBallotMeasuresImage from "../../../../content/research/2025-11-17-too-many-ballot-measures/too-many-ballot-measures.jpg";
import charterAmendmentsImage from "../../../../src/images/charter-amendments-og.png";
import longestCharterImage from "../../../../content/research/2025-04-21-sf-city-charter-longest-in-america/sf-longest-city-charter.png";
import lockedInStoneImage from "../../../../content/research/2025-12-01-laws-cast-in-stone/locked-in-stone.jpg";
import * as React from 'react';
export default {
  tooManyBallotMeasuresImage,
  charterAmendmentsImage,
  longestCharterImage,
  lockedInStoneImage,
  React
};